import { Vue, Component } from 'vue-property-decorator';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { HistoryItemType } from '@/features/shipment-history/types';

@Component
export class SchedulePickupMixin extends Vue {
  public showPickupSpecificsModal = false;

  public selectedShipmentHistoryItem: HistoryItemType | null = null;

  mounted(): void {
    eventBus.$on(eventNames.CONTINUE_SCHEDULE_PICKUP, this.continueSchedulePickup);
  }

  // eslint-disable-next-line class-methods-use-this
  destroyed(): void {
    eventBus.$off(eventNames.CONTINUE_SCHEDULE_PICKUP);
  }

  private continueSchedulePickup(selectedItem: HistoryItemType) {
    this.selectedShipmentHistoryItem = { ...selectedItem };
    this.showPickupSpecificsModal = true;
  }
}
